<app-banner *ngIf="dataHome" [banner]="dataHome.banner" [summary]="dataHome.summary"></app-banner>
<section class="home page" *ngIf="dataHome">
    <app-whatsapp></app-whatsapp>
    <app-highlight-product [data]="dataHome"></app-highlight-product>

    <div class="carousel">
        <app-tabs>
            <app-tab *ngFor="let tab of dataTabs; let i = index" [tabTitle]="lang == 'es' ? tab.name_es : tab.name" [active]="i === 0">
                <app-carousel [data]="dataHome.carousel" [buyBtn]="buyBtn" [knowBtn]="knowBtn"></app-carousel>
            </app-tab>
        </app-tabs>
    </div>

    <app-product-banner [data]="dataHome"></app-product-banner>
    <app-know-more [data]="dataHome"></app-know-more>

    <div class="home__banner" *ngIf="lang === 'pt'; else bannerEs">
        <a class="ga-click" data-ga-reference="onde-encontrar" [routerLink]="'/' + lang + '/onde-encontrar'">
            <figure class="desktop">
            <img src="/assets/images/Institucional.png" alt="banner onde encontrar">
            </figure>
            <figure class="mobile">
            <img src="/assets/images/banner-onde-encontrar-mobile.jpg" alt="banner onde encontrar">
            </figure>
        </a>
    </div>

    <ng-template #bannerEs>
        <div class="home__banner">
            <a class="ga-click" data-ga-reference="onde-encontrar"  [routerLink]="'/' + lang + '/onde-encontrar'">
            <figure class="">
                <img src="/assets/images/Institucional-es.png" alt="banner donde encontrar">
            </figure>
            </a>
        </div>
    </ng-template>
    <!-- <app-reseller [data]="dataHome"></app-reseller> -->
    <!-- <app-procure-aqui></app-procure-aqui> -->
     <!-- <div class="pop-up__alert" *ngIf="viewPopUp && lang === 'pt'" >
        <figure >
            <img src="/assets/images/popup-alerta.png" alt="Pop Up">
        </figure>
        <button class="close" (click)="closePopUp()">
            <img src="/assets/images/close-menu.svg" alt="Fechar" title="Fechar">
        </button>
     </div> -->
</section>